import { useTranslator } from "components/Translator"
import { hasAddressData } from "domains/address/model"
import { LabelWithIcon } from "components/LabelWithIcon"
import { Home } from "components/Icon"
import * as Civility from "enums/Civility"
import { formatAddress } from "utils/formatAddress"

export const UserPrimaryAddress = ({ user }) => {
  const translator = useTranslator()
  const address = user.primaryAddress

  if (!hasAddressData(address)) {
    return null
  }

  return (
    <LabelWithIcon
      icon={<Home className="w-4 text-primary-default" />}
      label={
        user.civility?.enum_value === Civility.ORGANIZATION
          ? translator.trans(
              "UserInfos.headquartersAddress",
              {
                address: address.formatted ? address.formatted : address.search,
              },
              "components",
            )
          : address.search
            ? address.search
            : formatAddress(address)
      }
    />
  )
}
